export default angular.module('videoPlayer', [])
    /**
     * @ngdoc controller
     * @name video.controller:videoController
     * @description
     * Scope for a video player and thumbnails
     */
    // @ngInject
    .controller('videoController', function ($sce, $timeout) {
        var controller = this;
        var videos = [];
        var active_video = null;
        var player_parameters = '?rel=0&amp;autoplay=1&amp;showinfo=0&amp;wmode=transparent&amp;enablejsapi=1';
        var is_playing = false;

        this.startPlaying = function () {
            is_playing = true;
        };

        this.stopPlaying = function () {
            is_playing = false;
        };

        this.togglePlaying = function (state) {
            is_playing = typeof state === 'boolean' ? state : !is_playing;
        };

        // Return an array of all registered videos
        this.getVideos = function () {
            return videos;
        };

        // Return the first registered video
        this.getFirstVideo = function () {
            if (videos.length) {
                return videos[0];
            }
            return null;
        };

        // Set an active video. Second parameter plays the video if truthy
        this.setActiveVideo = function (video_data, play) {
            $timeout(function () {
                is_playing = !!play;
                active_video = video_data;
            });
        };

        // Return the active video
        this.getActiveVideo = function () {
            return active_video;
        };

        // Mark the active video as playing
        this.playActiveVideo = function () {
            if (active_video) {
                $timeout(function () {
                    is_playing = true;
                });
            }
            return null;
        };

        this.watchVideo = function (index) {
            controller.setActiveVideo(videos[index], true);
        };

        // Mark the active video as NOT playing
        this.stopActiveVideo = function () {
            if (active_video) {
                $timeout(function () {
                    is_playing = false;
                });
            }
            return null;
        };

        // Return the active video state
        this.isActiveVideoPlaying = function () {
            return is_playing;
        };

        // Return the URL for the active video
        this.getActiveVideoURL = function () {
            if (active_video) {
                return active_video.url;
            }
            return null;
        };

        // Return the title text for the active video
        this.getActiveVideoTitle = function () {
            if (active_video) {
                return active_video.title;
            }
            return null;
        };

        // Return the description text for the active video
        this.getActiveVideoDescription = function () {
            if (active_video) {
                return active_video.description;
            }
            return null;
        };

        // Return the image path for the video preview/placehlder
        this.getActiveVideoPlaceholder = function () {
            if (active_video) {
                return active_video.preview;
            }
            return null;
        };

        // Create a trusted URL object (SCE) with our default YouTube params
        this.makeTrustedURL = function (url) {
            return $sce.trustAsResourceUrl(url + player_parameters);
        };

        // Add video metadata to the videos array
        // If this is the first video, also make it active
        this.registerVideo = function (video_data) {
            videos.push(video_data);
            active_video = active_video || video_data;
            return video_data;
        };
    })
    /**
     * @ngdoc directive
     * @name video.directive:videos
     * @description
     * Wrap a video player and thumbnails
     */
    // @ngInject
    .directive('videos', function () {
        return {
            controller: 'videoController',
            link: function ($scope, $element, attrs, controller) {
                $scope.getVideos = controller.getVideos;
                $scope.videoTitle = controller.getActiveVideoTitle;
                $scope.videoDescription = controller.getActiveVideoDescription;
                $scope.videoPlaceholder = controller.getActiveVideoPlaceholder;
            }
        };
    })
    /**
     * @ngdoc directive
     * @name video.directive:videoPlayer
     * @description
     * Add functionality to a video player element
     */
    // @ngInject
    .directive('videoPlayer', function () {
        /*
         * THE INLINE STYLES CAN BE REMOVED ONCE THEY GET REPLICATED IN THE CSS
         */
        return {
            restrict: 'E',
            replace: true,
            template: '<iframe id="video-player-embed" class="video-player-embed" ng-if="isVideoPlaying()" ng-src="{{ getVideoURL() }}" frameborder="0" allowfullscreen></iframe>',
            require: '^^videos',
            link: function ($scope, $element, attrs, controller) {
                $scope.getVideoURL = controller.getActiveVideoURL;
                $scope.isVideoPlaying = controller.isActiveVideoPlaying;
                $scope.getPlaceholder = controller.getActiveVideoPlaceholder;
            }
        };
    })
    /**
     * @ngdoc directive
     * @name video.directive:videoItem
     * @description
     * Add functionality to a video item thumbnail
     */
    // @ngInject
    .directive('videoItem', function () {
        return {
            require: '^^videos',
            link: function ($scope, $element, attrs, controller) {
                var video = controller.registerVideo({
                    url: controller.makeTrustedURL(attrs.videoItemUrl),
                    title: attrs.videoItemTitle,
                    description: attrs.videoItemDescription,
                    preview: attrs.videoItemPreview
                });
                $element.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    controller.setActiveVideo(video, false);
                });
                $scope.$watch(controller.getActiveVideo, function (active_video) {
                    if (active_video) {
                        $element.toggleClass('video-item--active', video.url === active_video.url);
                    }
                });
            }
        };
    })

    .directive('videoItemPlayIndex', function () {
        return {
            require: '^^videos',
            link: function ($scope, $element, attrs, controller) {
                $element.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    controller.watchVideo(attrs.videoItemPlayIndex);
                    return false;
                });
            }
        };
    })

    /**
     * @ngdoc directive
     * @name video.directive:videoPreview
     * @description
     * Sets the video preview placeholder
     */
    // @ngInject
    .directive('videoPreview', function () {
        return {
            require: '^^videos',
            link: function ($scope, $element, attrs, controller) {
                $element.on('click', function (e) {
                    e.preventDefault();
                    controller.playActiveVideo();
                });
            }
        };
    })

    /**
     * @ngdoc directive
     * @name video.directive:videoPlayerEmbed
     * @description
     * Watch for changing YouTube IFRAME src changes
     */
    // @ngInject
    .directive('videoPlayerEmbed', function (VideoAnalyticsService) {
        return {
            restrict: 'C',
            link: function ($scope, $element, attrs) {
                attrs.$observe('ngSrc', function () {
                    VideoAnalyticsService.registerPlayer($element);
                });
            }
        };
    })
    .directive('iframe', function (VideoAnalyticsService) {
        return {
            restrict: 'E',
            link: function ($scope, $element, attrs) {
                if (attrs.src && attrs.src.indexOf('youtube') >= 0) {
                    VideoAnalyticsService.registerPlayer($element);
                }
            }
        };
    });
